import React, { useEffect, useState } from "react";
import { ContactInfo } from "./Utils/CustomerLabelInput";
import { RiErrorWarningLine } from "react-icons/ri";
import Subscription from "./Subscription";
import Button from "@mui/material/Button";
import { useGetRoleManagementsQuery } from "../../../Service/roleManagement";
import AntSwitch from "../../../Component/DigitalMarketing/AntSwitch";
import SelectMenuItem from "../../../Component/DigitalMarketing/SelectMenuItem";
import {
  useAddUserManagementMutation,
  useUpdateUserManagementMutation,
} from "../../../Service/userManagment";
import { validatePhone } from "../../../utils";
import PermissionCheck from "../../../Component/PermissionCheck";

const initialUser = {
  full_name: "",
  email: "",
  active_status: 0,
  role_id: null,
  profile_image: "",
  id: null,
};
function CustomerDetails(props) {
  const [pagination, setpagination] = useState(1);

  const pagi = {
    pageNo: pagination,
  };
  const { data: RoleManagementsResponse, refetch } = useGetRoleManagementsQuery(
    pagi,
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const [addUserManagement, { isLoading: addloading }] =
    useAddUserManagementMutation();
  const [updateUserManagement, { isLoading: updateloading }] =
    useUpdateUserManagementMutation();
  const [roles, setRoles] = useState([]);
  const [user, setUser] = useState(props.user);
  const [submit, setSubmit] = useState(false);

  useEffect(() => {}, [pagination]);
  useEffect(() => {
    // setUser(props.user)
  }, [props]);

  useEffect(() => {
    if (RoleManagementsResponse) {
      setRoles(
        RoleManagementsResponse?.data
          .filter((item) => item.activeStatus == 1)
          .map((item) => ({ label: item.roleName, value: item.id }))
      );
    }
  }, [RoleManagementsResponse]);

  const handleChangeInfo = (event, check = false, role = false) => {
    const { name, value, checked } = event.target;
    // console.log(name, value, checked, "valllll");
    setSubmit(false);
    if (check) {
      setUser((prev) => {
        return { ...prev, [name]: checked ? 1 : 0 };
      });
    } else if (role) {
      setUser((prev) => {
        return { ...prev, [name]: value };
      });
    } else {
      setUser((prev) => {
        return { ...prev, [name]: value };
      });
      // console.log(name, value);
    }
  };

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  const onSave = async () => {
    // console.log(user);

    setSubmit(true);
    if (
      user.fullName.trim().length !== 0 &&
      validateEmail(user.email) &&
      validatePhone(user.phoneNumber) &&
      user.roleId
    ) {
      if (user.id) {
        try {
          const payload = await updateUserManagement({
            id: user.id,
            ...user,
          }).unwrap();
          // console.log("fulfilled", payload);
          props.openSnackBar("Updated successfully");
        } catch (error: any) {
          props.openSnackBar(error.data.error, "error");
          console.error("rejected", error);
        }
      } else {
        try {
          const payload = await addUserManagement({ ...user }).unwrap();
          // console.log("fulfilled", payload);
          props.openSnackBar("Added successfully");
        } catch (error: any) {
          props.openSnackBar(error.data.error, "error");
          console.error("rejected", error);
        }
      }
      props.setshow(false);
    }
  };

  const validate = (value) => {
    if (value) {
      return value.trim().length !== 0;
    } else {
      return false;
    }
  };

  // console.log(user);

  return (
    <>
      <li className="d-flex">
        {/* <div>
          <img
            src={require("../../../assets/DigitalMarketing/image/dummy_img.png")}
            width="70px"
          >
            <input type='file'/>
          </img>
        </div> */}
        <div>
          {" "}
          <input
            type="text"
            placeholder="User name"
            name="fullName"
            value={user.fullName}
            style={{
              border: !validate(user.fullName) && submit ? "1px solid red" : "",
            }}
            onChange={handleChangeInfo}
            className="text-custom-title mt-3 mb-2"
          />
        </div>
      </li>
      <li>
        <p className="title mt-2 mb-1">Details</p>
      </li>
      {ContactInfo.map((a, i) => {
        if (user.id) {
          if (a.name === "password") {
            return <></>;
          }
        }
        return (
          <li className="input-custom" key={i}>
            <a.tag
              img={a.img}
              label={a.label}
              name={a.name}
              handleChange={handleChangeInfo}
              value={user[a.name]}
              submit={submit}
              required={a.required}
              validation={a.validation}
            />
          </li>
        );
      })}
      <li className="input-custom">
        <>
          <span className="det-label">{"Active"}</span>
          <AntSwitch
            checked={user.activeStatus == 1}
            onChange={(e) => handleChangeInfo(e, true)}
            name="activeStatus"
            inputProps={{ "aria-label": "ant design" }}
          />
        </>
      </li>

      <li>
        <p className="title mt-2 mb-1">Permissions</p>
      </li>
      <div style={{ marginBottom: 10 }}>
        <SelectMenuItem
          styles={"select"}
          name="roleId"
          option={roles}
          value={user.roleId}
          label="Select Role"
          submit={submit}
          handleChange={(e) => handleChangeInfo(e, false, true)}
        />
      </div>

      {/* {HospitalInfo.map((a, i) => (
        <li className="input-custom" key={i}>
          <a.tag
            img={a.img}
            label={a.label}
            name={a.name}
            handleChange={handleChangesetmedical}
          />
        </li>
      ))} */}

      {/* <input
        className="inp"
        placeholder="Type your own (Hit tab to add your custom label)"
      />
      <li>
        <p className="title mt-2 mb-1">Subscription <RiErrorWarningLine/></p>
      </li>
      <Subscription/> */}
      {user.id && (
        <div className="d-flex justify-content-center">
          {props.cancel}
          <Button
            onClick={onSave}
            disabled={updateloading}
            variant="contained"
            id="btn-save"
          >
            {updateloading ? "Wait" : "Update"} &#x2713;
          </Button>
        </div>
      )}
      {!user.id && (
        <div className="d-flex justify-content-center">
          {props.cancel}
          <Button
            onClick={onSave}
            disabled={addloading}
            variant="contained"
            id="btn-save"
          >
            {addloading ? "Wait" : "Save"} &#x2713;
          </Button>
        </div>
      )}
    </>
  );
}

export default React.memo(CustomerDetails);
